/** Kiểm tra form địa điểm phía trình duyệt — dùng cho nút "Tiếp tục", bước "Kiểm tra" và khi lưu. */

export const STEP_OF_FIELD = {
  name: "basic",
  slug: "basic",
  category: "basic",
  phone: "basic",
  shortIntro: "basic",
  description: "basic",
  priceMax: "basic",
  openTime: "basic",
  closeTime: "basic",
  seoTitle: "basic",
  seoDescription: "basic",
  image: "media",
  gallery: "media",
  videos: "media",
  latitude: "location",
  longitude: "location",
};

export const STEP_ORDER = ["basic", "media", "location", "review"];
export const STEP_LABEL = { basic: "Thông tin", media: "Media", location: "Vị trí", review: "Kiểm tra" };

const TIME_RE = /^([01]?\d|2[0-3]):[0-5]\d$/;
const PHONE_RE = /^[0-9+().\-\s]{6,20}$/;
const textLen = (s) => String(s || "").replace(/<[^>]*>/g, "").trim().length;

/** "11,9404" (kiểu VN/iOS) hay "11.9404" đều được. */
export function parseCoord(v) {
  if (v == null || v === "") return NaN;
  if (typeof v === "number") return Number.isFinite(v) ? v : NaN;
  let s = String(v).trim().replace(/\s/g, "");
  if (/^-?\d+,\d+$/.test(s)) s = s.replace(",", ".");
  else s = s.replace(/,/g, "");
  const n = Number(s);
  return Number.isFinite(n) ? n : NaN;
}

/**
 * @returns {{ errors: Record<string,string>, blockers: Array<{field:string,message:string}>, hints: Array<{field:string,message:string}> }}
 *  - errors: lỗi cần sửa trước khi LƯU (cả nháp)
 *  - blockers: còn thiếu để XUẤT BẢN (khớp cổng ở backend)
 *  - hints: gợi ý nâng chất lượng, không chặn
 */
export function validateLocationForm(form, draftMedia) {
  const errors = {};
  const name = String(form.name || "").trim();
  if (!name) errors.name = "Vui lòng nhập tên địa điểm";
  else if (name.length < 2) errors.name = "Tên quá ngắn (tối thiểu 2 ký tự)";
  else if (name.length > 200) errors.name = "Tên tối đa 200 ký tự";

  if (form.slug && !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(String(form.slug))) errors.slug = "Slug chỉ gồm chữ thường không dấu, số và dấu gạch ngang";
  if (!String(form.category || "").trim()) errors.category = "Vui lòng chọn danh mục";
  if (form.phone && !PHONE_RE.test(String(form.phone))) errors.phone = "Số điện thoại không hợp lệ";
  if (form.openTime && !TIME_RE.test(String(form.openTime))) errors.openTime = "Giờ phải theo dạng HH:mm (vd 07:30)";
  if (form.closeTime && !TIME_RE.test(String(form.closeTime))) errors.closeTime = "Giờ phải theo dạng HH:mm (vd 07:30)";
  if (String(form.shortIntro || "").length > 300) errors.shortIntro = "Giới thiệu ngắn tối đa 300 ký tự";

  const lat = parseCoord(form.latitude);
  const lng = parseCoord(form.longitude);
  if (!Number.isFinite(lat)) errors.latitude = "Vĩ độ không hợp lệ (vd 11,9404)";
  else if (lat < -90 || lat > 90) errors.latitude = "Vĩ độ phải trong khoảng -90 đến 90";
  if (!Number.isFinite(lng)) errors.longitude = "Kinh độ không hợp lệ (vd 108,4583)";
  else if (lng < -180 || lng > 180) errors.longitude = "Kinh độ phải trong khoảng -180 đến 180";

  const hasCover = Boolean(draftMedia?.cover?.url || draftMedia?.cover?.__localFile);
  const galleryN = Array.isArray(draftMedia?.gallery) ? draftMedia.gallery.length : 0;
  const blockers = [];
  if (!hasCover) blockers.push({ field: "image", message: "Cần có ảnh đại diện" });
  if (textLen(form.description) < 80) blockers.push({ field: "description", message: `Mô tả cần tối thiểu 80 ký tự (hiện ${textLen(form.description)})` });
  const hints = [];
  if (!String(form.shortIntro || "").trim()) hints.push({ field: "shortIntro", message: "Thêm giới thiệu ngắn" });
  if (galleryN < 3) hints.push({ field: "gallery", message: `Nên có ít nhất 3 ảnh trong thư viện (hiện ${galleryN})` });

  return { errors, blockers, hints };
}

/** Lỗi thuộc về một bước. */
export const errorsForStep = (errors, step) => Object.fromEntries(Object.entries(errors).filter(([k]) => STEP_OF_FIELD[k] === step));

/** Số lỗi mỗi bước. */
export function issueCountByStep(errors) {
  const out = { basic: 0, media: 0, location: 0, review: 0 };
  // Ô đã sửa được xoá lỗi bằng cách gán undefined — chỉ đếm lỗi còn nội dung
  Object.keys(errors).forEach((k) => {
    if (!errors[k]) return;
    const s = STEP_OF_FIELD[k];
    if (s) out[s] += 1;
  });
  return out;
}

/** Nhảy tới và focus ô lỗi đầu tiên (nếu đã render). */
export function focusFirstError(keys) {
  window.setTimeout(() => {
    for (const k of keys) {
      const wrap = document.querySelector(`[data-field="${k}"]`);
      const el = wrap?.querySelector('[contenteditable="true"]') || wrap?.querySelector("input, select, textarea, button");
      if (el) {
        el.scrollIntoView({ block: "center", behavior: "smooth" });
        el.focus({ preventScroll: true });
        return;
      }
    }
  }, 120);
}
